import { Link } from "react-router-dom";
import { Target, Eye, Shield, ArrowRight } from "lucide-react";
import { Section, SectionHeading, Eyebrow } from "@/components/Section";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="bg-ocean">
        <div className="mx-auto max-w-7xl px-6 py-20 text-center md:px-10 md:py-24">
          <Eyebrow>Who we are</Eyebrow>
          <h1 className="mx-auto mt-5 max-w-3xl text-4xl font-bold tracking-tight text-white sm:text-5xl">About Us</h1>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-300">An independent testing service helping people see what's really inside their supplements.</p>
        </div>
      </section>

      <Section>
        <div className="mx-auto max-w-3xl">
          <SectionHeading eyebrow="Our story" title="Transparency, by design" />
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-slate-600">
            <p>The supplement industry is lightly regulated, and what's printed on a label doesn't always match what's inside the bottle. We started TestMySupps to close that gap with objective, lab-grade analysis.</p>
            <p>Customers mail in their own supplements — testosterone boosters, GLP-1 and weight-loss products, vitamins, peptides and more. We analyze them and deliver a clear, factual report showing exactly what's there.</p>
            <p>We are strictly an independent testing service. We do not modify supplements, give medical advice, make health claims, or recommend products. Our only product is the truth.</p>
          </div>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {[
            { icon: Target, t: "Our Mission", d: "Give every person the facts they need to make informed decisions about what they consume." },
            { icon: Eye, t: "Our Approach", d: "Rigorous, repeatable lab methods — chosen to fit each supplement — and reports anyone can understand." },
            { icon: Shield, t: "Our Promise", d: "100% independent, with no brand affiliations and no conflicts of interest. Ever." },
          ].map((c) => (
            <div key={c.t} className="rounded-2xl border border-border bg-white p-8">
              <span className="grid h-12 w-12 place-items-center rounded-xl bg-accent"><c.icon className="h-6 w-6 text-teal-dark" /></span>
              <h3 className="mt-5 text-lg font-semibold text-ocean">{c.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{c.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link to="/pricing" className="inline-flex items-center gap-2 rounded-full bg-ocean px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-ocean-light">Get Started <ArrowRight className="h-5 w-5" /></Link>
        </div>
      </Section>
    </div>
  );
}
